import { SurveySettings } from '../../types';
import { apiError } from '../../utils/errors';
import { fetchWithRetry } from '../../utils/fetch-with-retry';
import { getApiBaseUrl } from '../../utils/api-base-url';

export const getSettingsByUrlSlug = async (urlSlug: string, metadataToken?: string): Promise<SurveySettings> => {
  const response = await fetchWithRetry(`${getApiBaseUrl()}/settings/${urlSlug}${metadataToken ? `?m=${metadataToken}` : ''}`);
  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch application');
  }

  const settings = responseJson.data;
  return settings;
};
